import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { ElementDTO, ElementDTOSchema, QueryParams1302DTO, StructureDTO, StructureDTOSchema } from "@mra/hlp9002";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { VALIDATION_SCHEMA_CONTEXT } from "../api/http-format-interceptor.service";

@Injectable({
  providedIn: "root"
})
export class PageStructureService {
  private readonly http = inject(HttpClient);

  /**
   * récupère la structure de la page (header, footer et breadcrumbs)
   * @returns structure
   */
  getPageStructure(): Observable<StructureDTO> {
    const context: HttpContext = new HttpContext().set(VALIDATION_SCHEMA_CONTEXT, StructureDTOSchema);
    return this.http.get<StructureDTO>(environment.urlsMs.MS1302, {
      context
    });
  }

  /**
   * récupère un élément particulier de la structure
   * @param codeElement code de l'élément
   * @returns element
   */
  getPageElement(codeElement: string): Observable<ElementDTO> {
    const msParams: QueryParams1302DTO = { codeElement };
    const context: HttpContext = new HttpContext().set(VALIDATION_SCHEMA_CONTEXT, ElementDTOSchema);
    return this.http.get<ElementDTO>(environment.urlsMs.MS1302, {
      context,
      params: msParams
    });
  }
}
